import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { JissuRoutes } from '@jissu-public/shared/model';

const BASE_PATH_VALUE = 'domov';

const ROUTES: JissuRoutes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: BASE_PATH_VALUE,
  },
  {
    path: 'admin',
    pathMatch: 'full',
    redirectTo: BASE_PATH_VALUE,
  },
  {
    path: BASE_PATH_VALUE,
    loadChildren: () => import('@jissu-public/jissu-public-dm-dc/base').then((m) => m.JissuPublicDmDcBaseModule),
    data: {
      breadcrumbs: ['breadcrumbs.home'],
    },
  },
  {
    // neznama adresa mimo /domov skonci na chybovej stranke, nie na prazdnom loaderi
    path: '**',
    redirectTo: `${BASE_PATH_VALUE}/nenajdene`,
  },
];

@NgModule({
  // anchorScrolling: odkazy s fragmentom (napr. pätička -> #admin-contact v Kontaktoch) sa posunú na sekciu (ADO 57423)
  imports: [RouterModule.forRoot(ROUTES, { anchorScrolling: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
